import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Header from './Header/Header';
import Dashboard from '../modules/Dashboard/Dashboard';
import Transactions from '../modules/Transactions/Transactions';
import Caisses from '../modules/Caisses/Caisses';
import CaisseDetails from '../modules/Caisses/CaisseDetails';
import Users from '../modules/Users/Users';
import UserDetails from '../modules/Users/UserDetails';
import Categories from '../modules/Categories/Categories';
import WithdrawalRequests from '../modules/WithdrawalRequests/WithdrawalRequests';
import WithdrawalRequestDetails from '../modules/WithdrawalRequests/WithdrawalRequestDetails';
import { useAuth } from '../context/AuthContext';

function Layout() {
    const { user } = useAuth();
    
    return (
        <div className="min-h-screen bg-[#F8F8F8]">
            {/* Header */}
            <Header />
            
            {/* Main Content */}
            <main>
                <Switch>
                    <Route exact path="/" render={() => (
                        (user?.role === 'AGENT') ? <Dashboard /> : 
                        (user?.role === 'POINTAGE_CLIENT' || user?.role === 'POINTAGE_COMPTABILITE') ? <Redirect to="/transactions" /> : 
                        <Dashboard />
                    )} />
                    <Route exact path="/dashboard" component={Dashboard} />
                    <Route path="/transactions">
                        <Transactions />
                    </Route>
                    <Route exact path="/caisses" component={Caisses} />
                    <Route path="/caisses/:id" component={CaisseDetails} />
                    <Route exact path="/users" component={Users} />
                    <Route path="/users/:id" component={UserDetails} />
                    <Route path="/categories" component={Categories} />
                    <Route exact path="/requests" component={WithdrawalRequests} />
                    <Route path="/requests/:id" component={WithdrawalRequestDetails} />
                </Switch>
            </main>
        </div>
    );
}

export default Layout;